// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5714 ? "11a89e4f" : chunkId) + "." + {"3829":"ad3aac471575aacb","4625":"9ef32e8a878bedac","5714":"5bb4b0133514ff3b"}[chunkId] + ".js";
};